var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "row",
    {
      staticClass: "is-alternative-hotel",
      nativeOn: {
        dblclick: function ($event) {
          return _vm.openModal.apply(null, arguments)
        },
      },
    },
    [
      _c("template", { slot: "type" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("local_hotel")]),
        _vm._v(" "),
        _vm.isDouble
          ? _c("i", { staticClass: "material-icons" }, [_vm._v("local_hotel")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("template", { slot: "name" }, [
        _c(
          "div",
          {
            staticClass: "alternative-hotel",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("span", { staticClass: "alternative-hotel__label" }, [
              _vm._v(_vm._s(_vm.label)),
            ]),
            _vm._v(" "),
            _vm.isDouble
              ? _c("multiselect", {
                  staticClass: "alternative-hotel__select is-shorter",
                  attrs: {
                    options: _vm.hotelOptions,
                    label: "name",
                    "track-by": "requestId",
                    placeholder: "Hotel auswählen",
                    "show-labels": false,
                  },
                  nativeOn: {
                    dblclick: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                  model: {
                    value: _vm.selectedHotel,
                    callback: function ($$v) {
                      _vm.selectedHotel = $$v
                    },
                    expression: "selectedHotel",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "marginTax" },
        [
          _c("margin-tax", {
            attrs: { tax: _vm.marginTax, margin: _vm.grossMargin },
            model: {
              value: _vm.marginTaxEnabled,
              callback: function ($$v) {
                _vm.marginTaxEnabled = $$v
              },
              expression: "marginTaxEnabled",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "buyPrice" }, [
        _c(
          "div",
          { staticClass: "alternative-hotel__buy" },
          [
            _c(
              "popover",
              { attrs: { trigger: "hover" } },
              [
                _c(
                  "i",
                  { staticClass: "material-icons alternative-hotel__info" },
                  [_vm._v("info_outline")]
                ),
                _vm._v(" "),
                _c("template", { slot: "popover" }, [
                  _c("strong", [_vm._v("Aufpreis für alle Nächte")]),
                  _c("br"),
                  _vm._v(
                    "\n                    (" +
                      _vm._s(_vm._f("priceView")(_vm.altPerNight)) +
                      " − " +
                      _vm._s(_vm._f("priceView")(_vm.currentPerNight)) +
                      ")\n                    × " +
                      _vm._s(_vm.nights) +
                      " " +
                      _vm._s(_vm.nights === 1 ? "Nacht" : "Nächte")
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    = " +
                      _vm._s(_vm._f("priceView")(_vm.buyPrice)) +
                      "\n                "
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("input-price", { attrs: { readOnly: "", value: _vm.buyPrice } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "sellPrice" },
        [
          _c("input-price", {
            model: {
              value: _vm.sellPrice,
              callback: function ($$v) {
                _vm.sellPrice = $$v
              },
              expression: "sellPrice",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "profit" },
        [
          _c("input-price", {
            model: {
              value: _vm.profit,
              callback: function ($$v) {
                _vm.profit = $$v
              },
              expression: "profit",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "margin" },
        [
          _c("input-price", {
            model: {
              value: _vm.margin,
              callback: function ($$v) {
                _vm.margin = $$v
              },
              expression: "margin",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "actions" }, [
        _c(
          "i",
          {
            staticClass: "material-icons",
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.deleteAlternative.apply(null, arguments)
              },
            },
          },
          [_vm._v("delete")]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }